import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shortenText'
})
export class ShortenTextPipe implements PipeTransform {
    constructor() { }

    transform(str: string, limit: number): string {
        if (!str?.length || str.length <= limit) return str;
        else return `${str.substring(0, limit - 3)}...`
    }
}
